export const modal_ui_styles = {
    overlay: 'z-49 bg-teal/90 backdrop-blur-xs pointer-events-none',
    content: 'z-50 max-w-[56.25rem] text-teal bg-white border-0',
    header: 'border-0 min-h-0',
    body: 'flex flex-col content-center items-center border-0',
    footer: 'border-0 flex flex-col content-center items-center xl:pb-[3.4375rem]',
    title: 'invisible h-0'
}

export const close_button_ui_styles = {
    color: 'transparent',
    variant: 'close',
    class: 'rounded-full border-teal border-1 hover:bg-teal hover:text-white',
}

export const drawer_close_button_ui_styles = {
    default: 'rounded-full bg-teal border-teal border-1 hover:bg-teal hover:text-white',
}

export const search_ui_styles = {
    content: 'bg-teal text-white',
    header: 'border-0 flex flex-col content-center items-end',
    body: 'flex flex-col justify-center border-0 h-full',
    footer: '',
    title: 'invisible h-0',
    description: 'invisible h-0',
}